export default "__VITE_ASSET__CAueVB1O__"